import { render, staticRenderFns } from "./Deliveries-Tab.vue?vue&type=template&id=4be1caee"
import script from "./Deliveries-Tab.vue?vue&type=script&lang=js"
export * from "./Deliveries-Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports